import { Component, ViewEncapsulation } from '@angular/core';
import { NgbProgressbar } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'zbp-star-progress-bar',
  templateUrl: './star-progress-bar.component.html',
  styleUrls: ['./star-progress-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class StarProgressBarComponent extends NgbProgressbar {
  get starImage(): string {
    return this.value >= this.max ? 'star.png' : 'star-empty.png';
  }

  get altText(): string {
    return this.value >= this.max ? 'All stars earned' : 'Not all stars earned';
  }
}
